import React from 'react';
import {IFileModel} from '../../@interfaces/models/FIle/IFileModel';
import DismissibleAttach from '../DismissibleAttach/DismissibleAttach';

export default function CommentListItemAttaches<T extends IFileModel>(props: {
    list?: T[],
    onDownload?: (file: T) => void,
    onDelete?: (file: T) => Promise<void> | void,
}) {
    const {onDelete, onDownload} = props;

    return <div className="comment-list__item__attaches">
        {props.list?.map((file) => {
            return <DismissibleAttach
                    key={file.id}
                    file={file}
                    onDownload={onDownload ? () => onDownload(file) : undefined}
                    onDismiss={onDelete ? (() => onDelete(file)) : undefined}
            />;
        })}
    </div>;
}
